export default __webpack_public_path__ + "static/media/Dead Sea Scrolls - All Souls Deuteronomy_01.1bb66ca9.jpg";